module.exports = __webpack_public_path__ + "img/ppe_apply_process.59e0397e.png";